module.exports = __webpack_public_path__ + "img/84.62ec312f.jpg";